import React, { useState, useEffect, useRef } from 'react';

const CSS_INJECT = `
  .nav-link:hover { color: #38bdf8; }
  .nav-link { transition: color 0.15s; }
  .cta-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(14,165,233,0.45); }
  .cta-btn { transition: all 0.18s cubic-bezier(.4,0,.2,1); }
  .step-card:hover { transform: translateY(-6px); box-shadow: 0 24px 60px rgba(14,165,233,0.18); }
  .step-card { transition: all 0.22s cubic-bezier(.4,0,.2,1); }
  .pricing-card:hover { transform: translateY(-8px); }
  .pricing-card { transition: all 0.25s cubic-bezier(.4,0,.2,1); }
  .orb1 { animation: orb 12s ease-in-out infinite; }
  .orb2 { animation: orb 16s ease-in-out infinite reverse; }
  .orb3 { animation: orb 10s ease-in-out infinite 4s; }
  .hero-badge { animation: fadeIn 0.6s ease both; }
  .hero-h1 { animation: fadeUp 0.7s ease 0.15s both; }
  .hero-sub { animation: fadeUp 0.7s ease 0.3s both; }
  .hero-cta { animation: fadeUp 0.7s ease 0.45s both; }
  .phone-mockup { animation: floatSlow 5s ease-in-out infinite; }
  .cloud-pill { animation: float 6s ease-in-out infinite; }
  .topic-preview-pill:hover { transform: scale(1.06); }
  .topic-preview-pill { transition: transform 0.15s; }
`;

const TOPICS_PREVIEW = [
  { name: 'Finance',       emoji: '💰', color: '#22c55e' },
  { name: 'AI',            emoji: '🤖', color: '#6366f1' },
  { name: 'Health',        emoji: '🏥', color: '#f43f5e' },
  { name: 'Fitness',       emoji: '💪', color: '#f97316' },
  { name: 'Crypto',        emoji: '₿',  color: '#f59e0b' },
  { name: 'Tech',          emoji: '💻', color: '#0ea5e9' },
  { name: 'Business',      emoji: '📈', color: '#10b981' },
  { name: 'Mental Health', emoji: '🧠', color: '#a855f7' },
  { name: 'Nutrition',     emoji: '🥗', color: '#84cc16' },
  { name: 'Productivity',  emoji: '⚡', color: '#facc15' },
  { name: 'Science',       emoji: '🔬', color: '#06b6d4' },
  { name: 'Space',         emoji: '🚀', color: '#818cf8' },
];

const SAMPLE_LINES = [
  '💧 Your DailyDroplet',
  '',
  '1. Why AI is reshaping investing in 2025',
  '   reddit.com/r/investing/...',
  '',
  '2. Top 5 beginner workouts (no equipment)',
  '   youtube.com/watch?v=...',
  '',
  '3. The science of deep sleep',
  '   reddit.com/r/health/...',
  '',
  '4. GPT-5 drops — what changed?',
  '   youtube.com/watch?v=...',
  '',
  '5. 10-minute morning routine for focus',
  '   reddit.com/r/productivity/...',
];

const STEPS = [
  { icon: '👤', num: '01', title: 'Tell us who you are', desc: 'Your name, your topics, your platforms. 60 seconds to set up.' },
  { icon: '⏰', num: '02', title: 'Pick your delivery time', desc: 'Choose any time that works for you — from 6 AM to 9 PM.' },
  { icon: '💧', num: '03', title: 'Get your droplet daily', desc: 'Five fresh, personalized links delivered to you every single day.' },
];


/* ─── Phone mockup ───────────────────────────────────────────────── */
function PhoneMockup() {
  const [visible, setVisible] = useState(0);
  const lines = SAMPLE_LINES;

  useEffect(() => {
    if (visible >= lines.length) return;
    const t = setTimeout(() => setVisible(v => v + 1), visible === 0 ? 800 : 175);
    return () => clearTimeout(t);
  }, [visible, lines.length]);

  useEffect(() => {
    if (visible < lines.length) return;
    const t = setTimeout(() => setVisible(0), 4000);
    return () => clearTimeout(t);
  }, [visible, lines.length]);

  return (
    <div className="phone-mockup" style={ph.shell}>
      <div style={ph.notch} />
      <div style={ph.screen}>
        <div style={ph.topBar}>
          <span style={ph.arrow}>‹</span>
          <div style={ph.contact}>
            <div style={ph.avatar}>D</div>
            <div>
              <div style={ph.name}>DailyDroplet</div>
              <div style={ph.sub}>Text message</div>
            </div>
          </div>
          <div style={{ color: '#0ea5e9', fontSize: 16 }}>⋯</div>
        </div>
        <div style={ph.msgs}>
          <div style={ph.time}>8:00 AM</div>
          <div style={ph.bubble}>
            {lines.slice(0, visible).map((l, i) => (
              <div key={i} style={l === '' ? { height: 4 } : { display: 'block' }}>{l}</div>
            ))}
            {visible < lines.length && <span style={ph.cursor}>|</span>}
          </div>
        </div>
        <div style={ph.inputBar}>
          <div style={ph.inputField}>iMessage</div>
          <div style={ph.sendBtn}>↑</div>
        </div>
      </div>
    </div>
  );
}

const ph = {
  shell: { width: 260, height: 520, background: 'linear-gradient(145deg,#1e293b,#0f172a)', borderRadius: 40, border: '2px solid #334155', boxShadow: '0 40px 80px rgba(0,0,0,0.6),inset 0 1px 0 rgba(255,255,255,0.08)', padding: '12px 8px 8px', position: 'relative', flexShrink: 0 },
  notch: { width: 80, height: 22, background: '#0f172a', borderRadius: 11, margin: '0 auto 6px' },
  screen: { background: '#000', borderRadius: 30, height: 'calc(100% - 30px)', overflow: 'hidden', display: 'flex', flexDirection: 'column' },
  topBar: { background: '#111', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #1e293b' },
  arrow: { color: '#0ea5e9', fontSize: 20, fontWeight: 300 },
  contact: { display: 'flex', alignItems: 'center', gap: 8, flex: 1 },
  avatar: { width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(135deg,#0ea5e9,#6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff' },
  name: { fontSize: 11, fontWeight: 600, color: '#f1f5f9' },
  sub: { fontSize: 9, color: '#64748b' },
  msgs: { flex: 1, padding: '12px 10px 8px', overflowY: 'auto', background: '#000' },
  time: { textAlign: 'center', fontSize: 9, color: '#64748b', marginBottom: 10 },
  bubble: { background: '#1c1c1e', borderRadius: '16px 16px 16px 4px', padding: '10px 12px', fontSize: 9.5, color: '#e2e8f0', lineHeight: 1.55, maxWidth: '92%', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word', minHeight: 40 },
  cursor: { display: 'inline-block', color: '#0ea5e9', fontWeight: 700, animation: 'typeCursor 0.8s step-end infinite' },
  inputBar: { background: '#111', padding: '8px 10px', display: 'flex', alignItems: 'center', gap: 6, borderTop: '1px solid #1e293b' },
  inputField: { flex: 1, background: '#1c1c1e', borderRadius: 16, padding: '5px 10px', fontSize: 9, color: '#475569' },
  sendBtn: { width: 22, height: 22, borderRadius: '50%', background: '#0ea5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#fff', fontWeight: 700 },
};

function Orbs() {
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
      <div className="orb1" style={{ position: 'absolute', top: '10%', left: '10%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle,rgba(14,165,233,0.12) 0%,transparent 70%)', filter: 'blur(20px)' }} />
      <div className="orb2" style={{ position: 'absolute', top: '40%', right: '5%', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle,rgba(99,102,241,0.10) 0%,transparent 70%)', filter: 'blur(20px)' }} />
      <div className="orb3" style={{ position: 'absolute', bottom: '10%', left: '30%', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle,rgba(168,85,247,0.10) 0%,transparent 70%)', filter: 'blur(20px)' }} />
    </div>
  );
}

function useReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.12 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

/* ─── Main ───────────────────────────────────────────────────────── */
export default function LandingPage({ onStartSignup, onManage, onTerms, onPrivacy }) {
  const [aboutRef, aboutVis]   = useReveal();
  const [demoRef, demoVis]     = useReveal();
  const [howRef, howVis]       = useReveal();
  const [topicsRef, topicsVis] = useReveal();
  const [pricingRef, pricingVis] = useReveal(); // kept for scroll animation on free banner

  return (
    <>
      <style>{CSS_INJECT}</style>

      {/* NAV */}
      <nav style={s.nav}>
        <div style={s.navInner}>
          <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}><div style={s.logo}>💧 <span style={s.logoText}>DailyDroplet</span></div></a>
          <div style={s.navLinks}>
            {['About', 'Demo', 'How it works'].map(l => (
              <a key={l} className="nav-link" href={`#${l.toLowerCase().replace(/ /g, '-')}`} style={s.navLink}>{l}</a>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {onManage && (
              <button onClick={onManage} style={s.navManage}>Manage</button>
            )}
            <button onClick={onStartSignup} className="cta-btn" style={s.navCta}>Get started →</button>
          </div>
        </div>
      </nav>

      <div style={s.page}>

        {/* HERO */}
        <section style={s.heroSection}>
          <Orbs />
          <div style={s.heroContent}>
            <div className="hero-badge" style={s.badge}>
              <span style={s.badgeDot} />
              No app · Email or SMS
            </div>
            <h1 className="hero-h1" style={s.h1}>
              Your morning<br />
              <span style={s.gradientText}>brain fuel</span><br />
              delivered daily.
            </h1>
            <p className="hero-sub" style={s.heroSub}>
              Pick your topics, choose your time. Every day we send you
              the top 5 links curated from across the web — straight to your inbox or phone.
              No scrolling. No noise.
            </p>
            <div className="hero-cta" style={s.heroButtons}>
              <button onClick={onStartSignup} className="cta-btn" style={s.primaryBtn}>
                💧 Get Started
              </button>
              <a href="#demo" style={s.ghostBtn}>See an example →</a>
            </div>
            <div style={s.heroBadges}>
              {['No app download', 'Unsubscribe anytime', 'Custom delivery time'].map(b => (
                <div key={b} style={s.heroPill}>✓ {b}</div>
              ))}
            </div>
          </div>
          <div style={s.heroTopicCloud}>
            {TOPICS_PREVIEW.map((t, i) => (
              <div key={t.name} className="cloud-pill" style={{
                ...s.cloudPill,
                animationDelay: `${i * 0.3}s`,
                borderColor: t.color + '44',
                color: t.color,
              }}>
                {t.emoji} {t.name}
              </div>
            ))}
          </div>
        </section>

        {/* ABOUT */}
        <section id="about" ref={aboutRef} style={s.section}>
          <div style={{
            ...s.aboutGrid,
            opacity: aboutVis ? 1 : 0,
            transform: aboutVis ? 'none' : 'translateY(40px)',
            transition: 'all 0.7s ease',
          }}>
            <div>
              <div style={s.sectionTag}>About</div>
              <h2 style={s.sectionTitle}>The internet is loud.<br /><span style={s.gradientText}>Your morning shouldn't be.</span></h2>
              <p style={s.bodyText}>Great content gets buried every single day. Reddit threads with thousands of upvotes, YouTube deep-dives that change how you think — they disappear in the noise.</p>
              <p style={s.bodyText}>DailyDroplet surfaces the best of it, matched to your exact interests, and delivers it straight to you — by email or SMS (coming soon).</p>
              <div style={s.statRow}>
                {[['30', 'Topics'], ['100+', 'Sources'], ['5', 'Links/day'], ['Any', 'Delivery time']].map(([n, l]) => (
                  <div key={l} style={s.stat}>
                    <span style={s.statNum}>{n}</span>
                    <span style={s.statLabel}>{l}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={s.aboutIllustration}>
              <div style={s.glowCard}>
                {['Reddit', 'YouTube'].map(src => (
                  <div key={src} style={s.sourceRow}>
                    <div style={s.sourceIcon}>{src === 'Reddit' ? '🔴' : '▶️'}</div>
                    <div>
                      <div style={s.sourceName}>{src}</div>
                      <div style={s.sourceDesc}>{src === 'Reddit' ? 'Top posts from curated subreddits' : 'Most recent videos on your topics'}</div>
                    </div>
                    <div style={s.sourceArrow}>→</div>
                  </div>
                ))}
                <div style={s.arrowDown}>↓</div>
                <div style={s.resultBox}>
                  <div style={s.resultLabel}>Your personalized digest</div>
                  <div style={s.resultDesc}>5 links · Curated · Deduplicated · Sent at your time</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* DEMO */}
        <section id="demo" ref={demoRef} style={s.section}>
          <div style={{ opacity: demoVis ? 1 : 0, transform: demoVis ? 'none' : 'translateY(40px)', transition: 'all 0.7s ease' }}>
            <div style={s.centerHeader}>
              <div style={s.sectionTag}>Demo</div>
              <h2 style={s.sectionTitle}>What lands in your inbox<br /><span style={s.gradientText}>every morning</span></h2>
              <p style={s.centerSub}>Watch a real digest arrive, link by link.</p>
            </div>
            <div style={s.demoLayout}>
              <PhoneMockup />
              <div style={s.demoExplainer}>
                <h3 style={s.demoTitle}>Clean. Fast. Personal.</h3>
                {[
                  { icon: '🎯', t: 'Only your topics', d: 'Every link matches something you actually care about.' },
                  { icon: '🔗', t: 'Real links, real sources', d: 'Direct to Reddit threads and YouTube videos — no middleman.' },
                  { icon: '✨', t: 'Deduplicated daily', d: 'We filter duplicates so you always see fresh content.' },
                  { icon: '⏰', t: 'Your time, your rules', d: 'From 6 AM to 9 PM — pick the moment that works for you.' },
                ].map(item => (
                  <div key={item.t} style={s.demoFeature}>
                    <div style={s.demoFeatureIcon}>{item.icon}</div>
                    <div>
                      <div style={s.demoFeatureTitle}>{item.t}</div>
                      <div style={s.demoFeatureDesc}>{item.d}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section id="how-it-works" ref={howRef} style={s.section}>
          <div style={s.centerHeader}>
            <div style={s.sectionTag}>How it works</div>
            <h2 style={s.sectionTitle}>Up and running in<br /><span style={s.gradientText}>60 seconds</span></h2>
          </div>
          <div style={s.stepsGrid}>
            {STEPS.map((step, i) => (
              <div key={step.title} className="step-card" style={{
                ...s.stepCard,
                opacity: howVis ? 1 : 0,
                transform: howVis ? 'none' : 'translateY(40px)',
                transition: `all 0.6s ease ${i * 0.15}s`,
              }}>
                <div style={s.stepNum}>{step.num}</div>
                <div style={s.stepEmoji}>{step.icon}</div>
                <h3 style={s.stepTitle}>{step.title}</h3>
                <p style={s.stepDesc}>{step.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* TOPICS PREVIEW */}
        <section id="topics" ref={topicsRef} style={s.section}>
          <div style={{ opacity: topicsVis ? 1 : 0, transform: topicsVis ? 'none' : 'translateY(30px)', transition: 'all 0.6s ease' }}>
            <div style={s.centerHeader}>
              <div style={s.sectionTag}>Topics</div>
              <h2 style={s.sectionTitle}><span style={s.gradientText}>30 topics</span> to choose from</h2>
              <p style={s.centerSub}>Mix and match. The wizard lets you pick exactly what you want.</p>
            </div>
            <div style={s.topicsPreviewGrid}>
              {TOPICS_PREVIEW.concat([
                { name: 'Sports',        emoji: '🏆', color: '#fb923c' },
                { name: 'Gaming',        emoji: '🎮', color: '#c084fc' },
                { name: 'Travel',        emoji: '✈️', color: '#34d399' },
                { name: 'Climate',       emoji: '🌍', color: '#4ade80' },
                { name: 'Food',          emoji: '🍕', color: '#f87171' },
                { name: 'Startups',      emoji: '🦄', color: '#e879f9' },
                { name: 'Design',        emoji: '🎨', color: '#f472b6' },
                { name: 'Self-Improvement', emoji: '🌱', color: '#a3e635' },
                { name: 'Philosophy',    emoji: '📚', color: '#94a3b8' },
                { name: 'World News',    emoji: '🗞️', color: '#64748b' },
                { name: 'Entertainment', emoji: '🎬', color: '#fb7185' },
                { name: 'Real Estate',   emoji: '🏠', color: '#fbbf24' },
                { name: 'Fashion',       emoji: '👗', color: '#f472b6' },
                { name: 'Music',         emoji: '🎵', color: '#a78bfa' },
                { name: 'Photography',   emoji: '📷', color: '#60a5fa' },
                { name: 'Parenting',     emoji: '👶', color: '#34d399' },
                { name: 'History',       emoji: '🏛️', color: '#fb923c' },
                { name: 'Automotive',    emoji: '🚗', color: '#94a3b8' },
              ]).map(({ name, emoji, color }) => (
                <div key={name} className="topic-preview-pill" style={{
                  ...s.previewPill,
                  borderColor: color + '44',
                  color: color,
                  background: color + '0f',
                }}>
                  {emoji} {name}
                </div>
              ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: 40 }}>
              <button onClick={onStartSignup} className="cta-btn" style={s.primaryBtn}>
                Pick my topics →
              </button>
            </div>
          </div>
        </section>

        {/* PRICING */}
        <section ref={pricingRef} style={{ ...s.section, paddingTop: 0 }}>
          <div style={{ opacity: pricingVis ? 1 : 0, transform: pricingVis ? 'none' : 'translateY(30px)', transition: 'all 0.6s ease' }}>
            <div style={s.centerHeader}>
              <div style={s.sectionTag}>Pricing</div>
              <h2 style={s.sectionTitle}>Simple, <span style={s.gradientText}>honest pricing.</span></h2>
              <p style={s.centerSub}>Pick your plan. Cancel anytime.</p>
            </div>
            <div style={{ display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap', maxWidth: 760, margin: '0 auto 40px' }}>
              {/* Basic */}
              <div style={{ flex: 1, minWidth: 280, background: 'rgba(14,165,233,0.05)', border: '1px solid rgba(14,165,233,0.2)', borderRadius: 20, padding: '36px 32px' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#0ea5e9', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Basic</div>
                <div style={{ marginBottom: 6 }}>
                  <span style={{ fontSize: 44, fontWeight: 800, color: '#f8fafc' }}>$5</span>
                  <span style={{ fontSize: 14, color: '#64748b' }}>/month</span>
                </div>
                <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>The daily essential — 5 hand-picked links every morning.</p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px' }}>
                  {['5 curated links per day', 'All 30 topics', 'Email delivery', 'Custom schedule & timezone', 'Cancel anytime'].map(f => (
                    <li key={f} style={{ fontSize: 14, color: '#94a3b8', marginBottom: 9 }}>
                      <span style={{ color: '#0ea5e9', marginRight: 8, fontWeight: 700 }}>✓</span>{f}
                    </li>
                  ))}
                </ul>
                <button onClick={onStartSignup} className="cta-btn" style={{ width: '100%', padding: '14px', fontSize: 14, fontWeight: 700, background: 'rgba(14,165,233,0.15)', color: '#0ea5e9', border: '1px solid rgba(14,165,233,0.3)', borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit' }}>
                  Get Basic →
                </button>
              </div>
              {/* Pro */}
              <div style={{ flex: 1, minWidth: 280, background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 20, padding: '36px 32px', position: 'relative' }}>
                <div style={{ position: 'absolute', top: -12, right: 24, background: 'linear-gradient(90deg,#3b82f6,#7c3aed)', color: '#fff', borderRadius: 999, padding: '4px 14px', fontSize: 11, fontWeight: 700 }}>Best value</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#818cf8', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Pro</div>
                <div style={{ marginBottom: 6 }}>
                  <span style={{ fontSize: 44, fontWeight: 800, color: '#f8fafc' }}>$8</span>
                  <span style={{ fontSize: 14, color: '#64748b' }}>/month</span>
                </div>
                <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>Double the signal — 10 curated links for the power reader.</p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px' }}>
                  {['10 curated links per day', 'All 30 topics', 'Email delivery', 'Custom schedule & timezone', 'Priority sources', 'Cancel anytime'].map(f => (
                    <li key={f} style={{ fontSize: 14, color: '#94a3b8', marginBottom: 9 }}>
                      <span style={{ color: '#818cf8', marginRight: 8, fontWeight: 700 }}>✓</span>{f}
                    </li>
                  ))}
                </ul>
                <button onClick={onStartSignup} className="cta-btn" style={{ width: '100%', padding: '14px', fontSize: 14, fontWeight: 700, background: 'linear-gradient(90deg,#3b82f6,#7c3aed)', color: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 4px 20px rgba(99,102,241,0.3)' }}>
                  Get Pro →
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* FINAL CTA BANNER */}
        <section style={s.ctaBanner}>
          <Orbs />
          <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
            <h2 style={{ ...s.sectionTitle, marginBottom: 16 }}>
              Your first droplet is<br /><span style={s.gradientText}>one tap away.</span>
            </h2>
            <p style={{ color: '#64748b', fontSize: 16, marginBottom: 32 }}>
              Takes 60 seconds. No account. No app.
            </p>
            <button onClick={onStartSignup} className="cta-btn" style={s.primaryBtn}>
              💧 Get Started
            </button>
          </div>
        </section>

        <footer style={s.footer}>
          <div style={s.footerLogo}>💧 DailyDroplet</div>
          <p style={s.footerSub}>Your morning brain fuel, delivered by text.</p>
          <div style={s.footerLinks}>
            <button onClick={onTerms} style={s.footerLink}>Terms of Service</button>
            <span style={{ color: '#1e3a5f' }}>·</span>
            <button onClick={onPrivacy} style={s.footerLink}>Privacy Policy</button>
            <span style={{ color: '#1e3a5f' }}>·</span>
            <button onClick={onManage} style={s.footerLink}>Manage Subscription</button>
          </div>
          <p style={s.footerCopy}>© {new Date().getFullYear()} DailyDroplet · Reply STOP to unsubscribe · Msg &amp; data rates may apply</p>
        </footer>

      </div>
    </>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#060d1f', color: '#f1f5f9' },
  nav: { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: 'rgba(6,13,31,0.85)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255,255,255,0.06)' },
  navInner: { maxWidth: 1100, margin: '0 auto', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 32 },
  logo: { fontSize: 20, fontWeight: 800, color: '#f1f5f9', display: 'flex', alignItems: 'center', gap: 6 },
  logoText: { background: 'linear-gradient(90deg,#38bdf8,#818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  navLinks: { display: 'flex', gap: 28, flex: 1, justifyContent: 'center' },
  navLink: { color: '#94a3b8', textDecoration: 'none', fontSize: 14, fontWeight: 500 },
  navManage: { background: 'none', border: '1px solid #1e3a5f', color: '#64748b', cursor: 'pointer', fontFamily: 'inherit', padding: '7px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, transition: 'border-color 0.15s, color 0.15s' },
  navCta: { background: 'linear-gradient(135deg,#0ea5e9,#6366f1)', color: '#fff', border: 'none', cursor: 'pointer', fontFamily: 'inherit', padding: '8px 20px', borderRadius: 8, fontSize: 14, fontWeight: 600 },
  heroSection: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 1100, margin: '0 auto', padding: '120px 24px 80px', position: 'relative', gap: 48 },
  heroContent: { flex: 1, maxWidth: 580, position: 'relative', zIndex: 1 },
  badge: { display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(14,165,233,0.12)', border: '1px solid rgba(14,165,233,0.3)', borderRadius: 999, padding: '6px 16px', fontSize: 13, fontWeight: 600, color: '#38bdf8', marginBottom: 24 },
  badgeDot: { width: 7, height: 7, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 6px #22c55e', animation: 'pulse 2s ease-in-out infinite', display: 'inline-block' },
  h1: { fontSize: 'clamp(2.6rem,6vw,4rem)', fontWeight: 800, lineHeight: 1.1, color: '#f8fafc', marginBottom: 24 },
  gradientText: { background: 'linear-gradient(90deg,#38bdf8 0%,#818cf8 50%,#c084fc 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundSize: '200% auto', animation: 'gradientShift 4s linear infinite', display: 'inline-block' },
  heroSub: { fontSize: 18, color: '#94a3b8', lineHeight: 1.75, marginBottom: 36 },
  heroButtons: { display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 28 },
  primaryBtn: { background: 'linear-gradient(135deg,#0ea5e9,#6366f1)', color: '#fff', border: 'none', cursor: 'pointer', fontFamily: 'inherit', padding: '14px 32px', borderRadius: 12, fontSize: 16, fontWeight: 700, display: 'inline-block', boxShadow: '0 4px 24px rgba(14,165,233,0.35)' },
  ghostBtn: { color: '#94a3b8', textDecoration: 'none', padding: '14px 24px', borderRadius: 12, fontSize: 15, fontWeight: 500, border: '1px solid #1e3a5f', display: 'inline-flex', alignItems: 'center' },
  heroBadges: { display: 'flex', gap: 12, flexWrap: 'wrap' },
  heroPill: { background: 'rgba(255,255,255,0.04)', border: '1px solid #1e3a5f', borderRadius: 999, padding: '5px 14px', fontSize: 12, color: '#64748b', fontWeight: 500 },
  heroTopicCloud: { display: 'flex', flexWrap: 'wrap', gap: 10, maxWidth: 340, justifyContent: 'flex-end', position: 'relative', zIndex: 1 },
  cloudPill: { background: 'rgba(255,255,255,0.03)', border: '1px solid', borderRadius: 999, padding: '7px 14px', fontSize: 13, fontWeight: 500 },
  section: { maxWidth: 1100, margin: '0 auto', padding: '100px 24px' },
  sectionTag: { display: 'inline-block', background: 'rgba(14,165,233,0.12)', border: '1px solid rgba(14,165,233,0.25)', color: '#38bdf8', borderRadius: 999, padding: '4px 14px', fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 16 },
  sectionTitle: { fontSize: 'clamp(1.8rem,4vw,2.8rem)', fontWeight: 800, lineHeight: 1.2, color: '#f8fafc', marginBottom: 16 },
  centerHeader: { textAlign: 'center', marginBottom: 56 },
  centerSub: { fontSize: 16, color: '#64748b', maxWidth: 500, margin: '0 auto' },
  aboutGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 64, alignItems: 'center' },
  bodyText: { fontSize: 16, color: '#94a3b8', lineHeight: 1.8, marginBottom: 16 },
  statRow: { display: 'flex', gap: 32, marginTop: 40, flexWrap: 'wrap' },
  stat: { display: 'flex', flexDirection: 'column', gap: 2 },
  statNum: { fontSize: 32, fontWeight: 800, color: '#38bdf8' },
  statLabel: { fontSize: 13, color: '#64748b', fontWeight: 500 },
  aboutIllustration: { display: 'flex', justifyContent: 'center' },
  glowCard: { background: 'rgba(14,165,233,0.05)', border: '1px solid rgba(14,165,233,0.15)', borderRadius: 20, padding: 28, boxShadow: '0 0 60px rgba(14,165,233,0.08)', minWidth: 280, display: 'flex', flexDirection: 'column', gap: 14 },
  sourceRow: { display: 'flex', alignItems: 'center', gap: 14, background: 'rgba(255,255,255,0.03)', borderRadius: 12, padding: '12px 16px' },
  sourceIcon: { fontSize: 22 },
  sourceName: { fontSize: 14, fontWeight: 600, color: '#f1f5f9' },
  sourceDesc: { fontSize: 12, color: '#475569' },
  sourceArrow: { marginLeft: 'auto', color: '#38bdf8', fontSize: 16 },
  arrowDown: { textAlign: 'center', fontSize: 22, color: '#38bdf8', margin: '4px 0' },
  resultBox: { background: 'linear-gradient(135deg,rgba(14,165,233,0.15),rgba(99,102,241,0.15))', border: '1px solid rgba(14,165,233,0.25)', borderRadius: 12, padding: '14px 16px', textAlign: 'center' },
  resultLabel: { fontSize: 14, fontWeight: 700, color: '#38bdf8', marginBottom: 4 },
  resultDesc: { fontSize: 11, color: '#64748b' },
  demoLayout: { display: 'flex', gap: 64, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' },
  demoExplainer: { maxWidth: 380, display: 'flex', flexDirection: 'column', gap: 24 },
  demoTitle: { fontSize: 24, fontWeight: 800, color: '#f1f5f9', marginBottom: 8 },
  demoFeature: { display: 'flex', gap: 16, alignItems: 'flex-start' },
  demoFeatureIcon: { width: 40, height: 40, borderRadius: 10, background: 'rgba(14,165,233,0.1)', border: '1px solid rgba(14,165,233,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 },
  demoFeatureTitle: { fontSize: 15, fontWeight: 700, color: '#f1f5f9', marginBottom: 3 },
  demoFeatureDesc: { fontSize: 13, color: '#64748b', lineHeight: 1.55 },
  stepsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 24 },
  stepCard: { background: 'rgba(255,255,255,0.03)', border: '1px solid #1e293b', borderRadius: 20, padding: '32px 28px', boxShadow: '0 4px 24px rgba(0,0,0,0.2)' },
  stepNum: { fontSize: 12, fontWeight: 800, color: '#1e3a5f', letterSpacing: 2, marginBottom: 16 },
  stepEmoji: { fontSize: 36, marginBottom: 16 },
  stepTitle: { fontSize: 18, fontWeight: 700, color: '#f1f5f9', marginBottom: 10 },
  stepDesc: { fontSize: 14, color: '#64748b', lineHeight: 1.65 },
  topicsPreviewGrid: { display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center', maxWidth: 800, margin: '0 auto' },
  previewPill: { border: '1px solid', borderRadius: 999, padding: '8px 16px', fontSize: 14, fontWeight: 500, cursor: 'default' },
  pricingGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))', gap: 24, alignItems: 'start' },
  pricingCard: { background: 'rgba(255,255,255,0.03)', border: '1px solid #1e293b', borderRadius: 20, padding: '32px 28px', position: 'relative' },
  pricingHighlight: { background: 'rgba(14,165,233,0.06)', border: '1px solid rgba(14,165,233,0.3)', boxShadow: '0 0 40px rgba(14,165,233,0.12)' },
  planBadge: { position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,#0ea5e9,#6366f1)', color: '#fff', borderRadius: 999, padding: '3px 14px', fontSize: 11, fontWeight: 700, letterSpacing: 0.5, whiteSpace: 'nowrap' },
  planName: { fontSize: 13, fontWeight: 700, color: '#64748b', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 },
  planPrice: { fontSize: 42, fontWeight: 800, color: '#f8fafc', marginBottom: 4 },
  planPeriod: { fontSize: 15, color: '#475569', fontWeight: 400 },
  planFeatures: { listStyle: 'none', margin: '24px 0', display: 'flex', flexDirection: 'column', gap: 12 },
  planFeature: { fontSize: 14, color: '#94a3b8', display: 'flex', gap: 8 },
  planCta: { display: 'block', width: '100%', textAlign: 'center', border: '1px solid #1e3a5f', color: '#94a3b8', borderRadius: 10, padding: '12px', fontSize: 14, fontWeight: 600, background: 'none', cursor: 'pointer', fontFamily: 'inherit' },
  planCtaHighlight: { background: 'linear-gradient(135deg,#0ea5e9,#6366f1)', border: 'none', color: '#fff', boxShadow: '0 4px 20px rgba(14,165,233,0.3)' },
  planNote: { textAlign: 'center', fontSize: 11, color: '#334155', marginTop: 10 },
  ctaBanner: { position: 'relative', overflow: 'hidden', background: 'rgba(14,165,233,0.03)', border: '1px solid #0d1829', borderRadius: 24, maxWidth: 1100, margin: '0 auto 80px', padding: '80px 24px' },
  footer: { borderTop: '1px solid #0d1829', padding: '48px 24px', textAlign: 'center' },
  footerLogo: { fontSize: 20, fontWeight: 800, color: '#1e3a5f', marginBottom: 8 },
  footerSub: { fontSize: 14, color: '#1e3a5f', marginBottom: 12 },
  footerLinks: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 16 },
  footerLink: { background: 'none', border: 'none', color: '#334155', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 500, transition: 'color 0.15s' },
  footerCopy: { fontSize: 12, color: '#1e3a5f' },
};
